/* talk·point — Kategorie-Verzeichnis (/collections, IT#16574).
   Klappt die Welten auf schmalen Viewports zu. Serverseitig stehen sie OFFEN:
   ohne JS bleibt der Inhalt sichtbar und crawlbar, das Zuklappen ist reine
   Bequemlichkeit fuer Mobilnutzer (429 Links = ~11.000px Scrollstrecke).
   Nur beim ersten Lauf, damit eine Nutzerentscheidung nicht ueberschrieben
   wird, wenn das Fenster spaeter die Schwelle kreuzt. */
(() => {
  const SCHWELLE = 700;
  const zuklappen = () => {
    if (window.innerWidth > SCHWELLE) return;
    document.querySelectorAll('.tp-cdir__col[open]').forEach((el) => {
      el.open = false;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', zuklappen, { once: true });
  } else {
    zuklappen();
  }
})();
